import { useRef } from "react";
import * as THREE from "three";

// Positions from the hand-off spec (section 5).
export const S_POS = new THREE.Vector3(-2.0, 1.15, 0); // Stanley (trapped)
export const B_POS = new THREE.Vector3(2.0, 1.5, 0); // Brian (intact side)

function createGame() {
  return {
    pov: "brian",
    phase: "impact",
    mode: "acoustic",

    // flashlight alignment
    sweep: -0.85,
    target: 0.075,
    autoAligning: false,
    autoEmit: true, // brian auto-emits rings; stanley taps
    emitClock: 0,
    aligned: false,
    firedAligned: false,

    // ring emit request counters (SoundRings consumes)
    _emitReq: 0,
    _emitAck: 0,
    emitsNeeded: 3,
    emitsDone: 0,

    // wrist-lock pull
    pullProgress: 0,
    pullFired: false,

    // descent
    descentFloor: 81,
    descentActive: false,
    xrDescend: false, // VR controller/hand descent input

    smoke: 0.1,
    wallOpacity: 0.5,
    roar: 0,
    evac: false, // global sprint state during the final street escape
    impactT: 0, // 0..1 mesh-fracture progress for the prologue

    // 360° free-look (drag/touch/VR) — steers where D-pad walks you
    lookYaw: 0,
    lookPitch: 0,

    // atmospheric smoke density dial (0..1), default 70%
    smokeDensity: 0.7,
    stanleyMotion: "idle", // idle | walk | crawl
    brianMotion: "idle",
    dpad: { up: false, down: false, left: false, right: false },
    hud: { countdown: "56:00", clock: "", breath: 100, stamina: 100, line: null, decay: false },

    // callbacks (set by orchestrator)
    onAligned: null,
    onPullComplete: null,
    onEmit: null,
    onHazard: null,

    emitPulse() {
      this._emitReq += 1;
      this.emitsDone += 1;
      this.onEmit && this.onEmit(this.emitsDone);
    },
    rotateFlash(d) {
      this.autoAligning = false;
      this.sweep = THREE.MathUtils.clamp(this.sweep + d, -1.5, 0.7);
    },
    setSweepNorm(n) {
      // n in [0,1] mapped to sweep range
      this.autoAligning = false;
      this.sweep = THREE.MathUtils.lerp(-1.5, 0.7, THREE.MathUtils.clamp(n, 0, 1));
    },
    autoAlign() {
      this.autoAligning = true;
    },
    setPull(v) {
      this.pullProgress = THREE.MathUtils.clamp(v, 0, 1);
      if (this.pullProgress >= 1 && !this.pullFired) {
        this.pullFired = true;
        this.onPullComplete && this.onPullComplete();
      }
    },
    // Prepare interaction state when entering a phase.
    enterPhase(phase, pov) {
      this.phase = phase;
      this.pov = pov;
      if (phase === "acoustic") {
        this.autoEmit = pov === "brian";
        this.emitsNeeded = pov === "brian" ? 2 : 3;
        this.emitsDone = 0;
        this.aligned = false;
        this.firedAligned = false;
        this.autoAligning = false;
        this.sweep = -0.85;
      }
      if (phase === "flashlight") {
        this.firedAligned = false;
      }
      if (phase === "wristlock") {
        this.pullProgress = 0;
        this.pullFired = false;
      }
      if (phase === "descent") {
        this.descentFloor = 81;
        this.descentActive = false;
        this.xrDescend = false;
      }
    },
  };
}

export function useGame() {
  const ref = useRef(null);
  if (!ref.current) ref.current = createGame();
  return ref;
}
